export default "__VITE_ASSET__BNL2gNuQ__"